import type OpenAI from 'openai'
import { findBomDescription, findBomName, findBomSchema, findBomShared } from '../../sharedTools/findBom'

export const findBomTool: OpenAI.ChatCompletionTool = {
  type: 'function',
  function: {
    name: findBomName,
    description: findBomDescription,
    parameters: findBomSchema,
  },
}

export async function findBom() {
  return findBomShared()
}
